import axios from "axios";
import { axiosBaseURL } from "../config/coilConfigurator/appConfig";
import { getJwtToken } from "./auth";

const coilConfiguratorAxiosConfig = axios.create({
  baseURL: axiosBaseURL || "/",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

coilConfiguratorAxiosConfig.interceptors.request.use(
  async (requestConfig) => {
    const authToken = await getJwtToken();
    if (authToken) {
      requestConfig.headers.Authorization = `Bearer ${authToken}`;
    }
    return requestConfig;
  },
  (error) => Promise.reject(error),
);

export default coilConfiguratorAxiosConfig;
